<template>
  <v-row>
    <v-col cols="7">
      <v-data-table
        :items="slides"
        item-key="id"
        :headers="headers"
        :loading="loading"
        disable-pagination
        hide-default-footer
        class="sliderTable elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Слайды</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="newSlide">
              Добавить слайд
            </v-btn>
          </v-toolbar>
        </template>
        <template #[`item.desktop`]="props">
          <v-img :src="props.item.desktop" max-width="188"></v-img>
        </template>
        <template #[`item.actions`]="{ item, index }">
          <v-btn
            icon
            class="buttonUp"
            title="поставить раньше"
            @click="moveItem(item.id, 'up')"
            :disabled="index === 0"
          >
            <v-icon small> mdi-arrow-up-thin-circle-outline </v-icon>
          </v-btn>
          <v-btn
            icon
            class="buttonDown"
            title="поставить позже"
            @click="moveItem(item.id, 'down')"
            :disabled="index === slides.length - 1"
          >
            <v-icon small> mdi-arrow-down-thin-circle-outline </v-icon>
          </v-btn>
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="checkRemove(item)"> mdi-delete </v-icon>
        </template>
      </v-data-table>
      <v-dialog v-model="deleteDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Удаление</span>
          </v-card-title>
          <v-card-text>
            Вы действительно хотите удалить этот слайд? Данное действие
            необратимо!
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="deleteDialog = false">
              Отмена
            </v-btn>
            <v-btn color="blue darken-1" text @click="remove"> Удалить </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col>
      <slider-props
        v-if="activeSlide"
        :data="activeSlide"
        @updateSlide="updateSlide"
        @updateAll="updateAll"
      />
      <p v-else>Выберите элемент для редактирования или создайте новый</p>
    </v-col>
    <snackbar v-bind.sync="snackbar" />
  </v-row>
</template>

<script>
import transport from "../../mixins/transport";
import Snackbar from "../Snackbar";
import SliderProps from "./Props";

export default {
  name: "SliderPage",
  components: { Snackbar, SliderProps },
  mixins: [transport],
  data() {
    return {
      name: "",
      activeSlide: null,
      emptySlide: {
        desktop: null,
        mobile: null,
        title_ru: "",
        title_kk: "",
        title_en: "",
        text_ru: "",
        text_kk: "",
        text_en: "",
        is_published: false
      },
      slides: [],
      editedIndex: -1,
      deleteDialog: false,
      deleteItem: null,
      headers: [
        {
          text: "#",
          value: "sort"
        },
        {
          text: "Превью",
          align: "start",
          sortable: false,
          value: "desktop"
        },
        { text: "Заголовок", value: "title_ru" },
        { text: "Действия", value: "actions", sortable: false }
      ]
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.exchange(
        (slides) => {
          this.slides = slides;
        },
        {},
        "slider"
      );
    },
    updateSlide(item, data) {
      this.replaceSlideById(data.id, data);
    },
    replaceSlideById(id, data) {
      this.slides.some((slide, n) => {
        if (slide.id === id) {
          this.slides[n] = data;
          return true;
        }
        return false;
      });
    },
    updateAll(slides, activeSlide) {
      this.slides = slides;
      this.activeSlide = activeSlide;
    },
    editItem(item) {
      this.activeSlide = item;
    },
    remove() {
      this.exchange(
        (data) => {
          this.slides = data;
        },
        null,
        "slider/remove/" + this.deleteItem.id,
        "post",
        null,
        () => {
          this.warningSnack("Удалено");
        }
      );
    },
    checkRemove(slide) {
      this.deleteItem = slide;
      this.deleteDialog = true;
    },
    newSlide() {
      this.activeSlide = this.emptySlide;
    },
    moveItem(id, dir) {
      this.exchange(
        (data) => {
          this.slides = data;
        },
        { dir },
        "slider/move/" + id + "/" + dir,
        "post"
      );
    }
  }
};
</script>
<style lang="scss">
.sliderTable tbody tr td:last-child {
  white-space: nowrap;
  text-align: right !important;
}

.sliderTable tbody tr:first-child .buttonUp,
.sliderTable tbody tr:last-child .buttonDown {
  display: none;
}
</style>
